<template>
  <form ref="posform">
    <Zmodalform
      cancel-button="Cancel"
      ok-button="Save"
      :width="650"
      @cancel-clicked="$emit('cancel-clicked')"
      @ok-clicked="okClicked"
    >
      <div class="col-10 pb-4 mt-3">
        <h2>Revi POS Plan</h2>
      </div>
      <!-- Payment Schedule -->
      <div
        class="col-2 pb-4 mt-3 d-flex align-items-center justify-content-center"
      >
        <select required v-model="pos_payment_schedule">
          <option value="monthly">Monthly</option>
          <option value="upfront">Upfront</option>
        </select>
      </div>

      <!-- Patron -->
      <div class="col-10 pb-4">
        <input
          v-model="pos_plan"
          value="patron"
          required
          class="mr-2"
          type="radio"
          id="patron"
          name="plan"
        />
        <label for="patron">
          <p class="mb-0 bold">Business Patron</p>
          <p class="sub-text m-0 pt-0">
            ${{ price("revi_pos_plan_patron_upfront") }} Upfront or ${{
              monthly("revi_pos_plan_patron_monthly")
            }}/mo for 12 months
          </p>
          <p class="sub-text m-0 pt-0">(Delivery cost not included)</p>
        </label>
      </div>
      <div class="col-2 pb-4 d-flex justify-content-center align-items-center">
        <div class="rectangle rectangle-yellow"></div>
      </div>
    </Zmodalform>
  </form>
</template>

<script>
import Zmodalform from "@/zcomponents/ZModalForm";
import { monthly, price } from "@/utils/prices";

export default {
  name: "ReviPOSPlanModal",
  components: { Zmodalform },
  props: {
    prices: Array,
    values: Object,
  },
  data() {
    return {
      pos_plan: this.values.pos_plan,
      pos_payment_schedule: this.values.pos_payment_schedule || "monthly",
    };
  },
  methods: {
    okClicked() {
      if (!this.$refs.posform.checkValidity()) {
        this.$refs.posform.reportValidity();
        return;
      }
      this.$emit("ok-clicked", this.$data);
    },
    price(key) {
      return price(this.prices, key);
    },
    monthly(key) {
      return monthly(this.prices, key);
    },
  },
};
</script>

<style scoped>
@import "../assets/css/select.css";

label {
  margin-bottom: 0;
}

.sub-text {
  text-align: left;
  letter-spacing: 0.15px;
  color: #0a1e42;
  opacity: 1;
}

.rectangle {
  height: 30px;
  width: 30px;
  background: gray;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 9px;
  opacity: 1;
}

.rectangle-blue {
  background: #2020df;
}

.rectangle-orange {
  background: #ff4f21;
}

.rectangle-yellow {
  background: #ffd74d;
}

@media (max-width: 499.99px) {
  .col-10 {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
